/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-05-08 09:19:17
 * @LastEditors: szj
 * @LastEditTime: 2025-09-10 14:42:41
 */
import request, { IWorkspaceResponse } from "/@/api/http/request";
import axios from "axios";
// 用于存储当前pending状态的杆量控制请求取消函数
let stickRequestCancel: (() => void) | null = null;
const API_PREFIX = "/control/api/v1";
// const workspaceId: string = localStorage.getItem(ELocalStorageKey.WorkspaceId) || '

// 获取飞行控制权
export async function postFlightAuth(
  sn: string
): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(
    `${API_PREFIX}/devices/${sn}/authority/flight`
  );
  return resp.data;
}
export enum WaylineLostControlActionInCommandFlight {
  CONTINUE = 0,
  EXEC_LOST_ACTION = 1,
}
export enum LostControlActionInCommandFLight {
  HOVER = 0, // 悬停
  Land = 1, // 着陆
  RETURN_HOME = 2, // 返航
}
export interface PointBody {
  latitude: number;
  longitude: number;
  height: number;
}
export interface PostFlyToPointBody {
  max_speed: number;
  points: PointBody[];
}

// 飞向目标点
export async function postFlyToPoint(
  sn: string,
  height: any,
  body: PostFlyToPointBody
): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(
    `${API_PREFIX}/devices/${sn}/jobs/fly-to-point/${height}`,
    body
  );
  return resp.data;
}

// 停止飞向目标点
export async function deleteFlyToPoint(
  sn: string
): Promise<IWorkspaceResponse<null>> {
  const resp = await request.delete(
    `${API_PREFIX}/devices/${sn}/jobs/fly-to-point`
  );
  return resp.data;
}

export interface PostTakeoffToPointBody {
  target_height: number;
  target_latitude: number;
  target_longitude: number;
  security_takeoff_height: number; // 安全起飞高
  max_speed: number; // flyto过程中能达到的最大速度, 单位m/s 跟飞机档位有关
  rc_lost_action: LostControlActionInCommandFLight; // 失控行为
  rth_altitude: number; // 返航高度
  exit_wayline_when_rc_lost: WaylineLostControlActionInCommandFlight;
  manual_height: number; // 相对地面高度
}

// 一键起飞
export async function postTakeoffToPoint(
  sn: string,
  body: PostTakeoffToPointBody
): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(
    `${API_PREFIX}/devices/${sn}/jobs/takeoff-to-point`,
    body
  );
  return resp.data;
}
// 恢复航线
export async function putResetLine(
  workspaceId: string,
  jobid: string,
  body: any
) {
  const resp = await request.put(
    `wayline/api/v1/workspaces/${workspaceId}/jobs/${jobid}`,
    body
  );
  return resp.data;
}
// 恢复航线
export async function putResetLine1(
  workspaceId: string,
  jobid: string,
  body: any
) {
  const resp = await request.put(
    `wayline/api/v1/workspaces/${workspaceId}/jobs/canEnter/${jobid}`,
    body
  );
  return resp.data;
}
// 按键进行 手动控制
export async function controlKeyApi(key: string, sn: string) {
  const url = `drc/control?command=${key}&sn=${sn}`;
  await request.get(url);
  return null;
}
// 按键进行 杆量控制
export async function controlKeyStickApi(
  sn: string,
  key: string,
  speed: string
) {
  const url = `remote/drc/stick/control/${sn}?command=${key}&speed=${speed}`;
  await request.get(url);
  return null;
}
// 按键进行 杆量控制
// export async function controlKeyStickApi(
//   sn: string,
//   key: string,
//   speed: string
// ) {
//   // 如果存在未完成的请求，先取消它
//   if (stickRequestCancel) {
//     stickRequestCancel();
//   }

//   try {
//     const url = `remote/drc/stick/control/${sn}?command=${key}&speed=${speed}`;
//     // 创建新的取消令牌
//     const source = axios.CancelToken.source();
//     stickRequestCancel = source.cancel;

//     await request.get(url, {
//       cancelToken: source.token, // 关联取消令牌
//     });
//     return null;
//   } catch (error) {
//     // 忽略取消请求导致的错误
//     if (axios.isCancel(error)) {
//       console.log("杆量控制请求已取消", error.message);
//       return null;
//     }
//     // 处理其他错误
//     console.error("杆量控制请求失败", error);
//     throw error;
//   } finally {
//     // 无论成功失败，清除取消函数引用（已完成或已取消）
//     stickRequestCancel = null;
//   }
// }

// 取消当前杆量控制请求（供键盘抬起时调用）
export function cancelStickControlRequest() {
  // if (stickRequestCancel) {
  //   stickRequestCancel();
  //   stickRequestCancel = null;
  // }
}
